import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import FSRList, { ListOptions } from "./FSRList";
import { DEFAULT_LIST_SORT } from "../../listSort";
import FSRCreate from "./FSRCreate";
import FSRReport from "./FSRReport";
import { hasAnyRole } from "../../utils/roles";
import { MDSplitView } from "@solsys/solsys-reactjs";
import "./fsr.css";

export default function FSRController({
    navigate,
    action,
    id,
    search,
    style,
}) {
    let listState = {
        [ListOptions.sortBy]: DEFAULT_LIST_SORT.sortBy,
        [ListOptions.sortDirection]: DEFAULT_LIST_SORT.sortDirection,
        [ListOptions.craneId]: null,
    };
    const { user } = useAuth();
    const didMount = useRef(false);
    const allowedRoles = ["administrator", "technician"];

    useEffect(() => (didMount.current ? undefined : (didMount.current = true)));

    if (!didMount.current && Object.keys(search).length) {
        Object.keys(ListOptions).forEach((key) => {
            listState[key] = search[key];
        });
    }

    listState = useState(listState);

    const canManage = hasAnyRole(user, allowedRoles);

    return (
        <div className="fsr">
            <MDSplitView
                globalName="FSRMDV"
                style={style}
                action={action}
                master={({ isNarrow, autoSelect }) => (
                    <FSRList
                        isMaster={canManage}
                        state={listState}
                        id={id}
                        action={action}
                        onStateChange={(state) => {
                            navigate({
                                action,
                                id,
                                search: state,
                                push: false,
                            });
                        }}
                        onSelect={(newId, userInteraction) => {
                            if (
                                newId &&
                                id &&
                                String(newId) === String(id) &&
                                userInteraction
                            ) {
                                navigate({
                                    popOut: isNarrow,
                                    action: "list",
                                    id: null,
                                    search: listState[0],
                                });
                            } else if (newId === 0) {
                                navigate({
                                    popOut: isNarrow,
                                    action: "add",
                                    id: null,
                                    search: listState[0],
                                });
                            } else {
                                navigate({
                                    popOut: isNarrow,
                                    action: "detail",
                                    id: newId,
                                    search: listState[0],
                                });
                            }
                        }}
                    />
                )}
                detail={() => {
                    if (action === "add") {
                        return (
                            <FSRCreate
                                key="fsr-create"
                                navigate={navigate}
                            />
                        );
                    }
                    if (action === "detail" && id) {
                        return <FSRReport key={`fsr-report-${id}`} id={id} />;
                    }
                    return (
                        <div className="fsr-detail-placeholder" style={{ padding: "1rem" }}>
                            Select an FSR from the list or create a new one.
                        </div>
                    );
                }}
                initialWidth={300}
                maxWidth={800}
                minWidth={290}
            />
        </div>
    );
}
